<template>
  <div>
    <div class="image-slider" ref="container">
      <img :src="imageLeft.url" :alt="imageLeft.alt" class="image-slider--image-left"/>
      <img :src="imageRight.url" :alt="imageRight.alt" class="image-slider--image-right" :style="clipPath"/>
      <div class="image-slider--divider" :style="dividerPosition">
        <button class="image-slider--drag-btn" @touchstart="onDragStart" @touchend="onDragEnd" @mousedown="onDragStart" @mouseup="onDragEnd" @blur="onDragEnd"><span
            class="image-slider--btn-text">drag me</span></button>
      </div>
    </div>
  </div>
</template>
<script>
    import cmsPlugin from '../../../mixins/cms/cms-plugin';

    export default {
        mixins: [cmsPlugin],
        data() {
            return {
                clipPosition: 0.5,
                currentPosition: 0.5,
            };
        },
        computed: {
            imageLeft() {
                return this.content.image_left;
            },
            imageRight() {
                return this.content.image_right;
            },
            clipPath() {
                const percent = 100 * this.clipPosition;
                return `clip-path: polygon(${ percent }% 0, 100% 0, 100% 100%, ${ percent }% 100%);`;
            },
            dividerPosition() {
                const percent = 100 * this.clipPosition;
                return `left: ${ percent }%;`;
            },
        },
        methods: {
            handleMouseMove(event) {
                const type = event.type;
                let mouseX = 0;
                if (type === 'touchmove') {
                    const touch = event.touches[0] || event.changedTouches[0];
                    mouseX = touch.clientX;
                } else {
                    mouseX = event.clientX;
                }
                const container = this.$refs.container;
                const { x, width } = container.getBoundingClientRect();
                const relativePosition = mouseX - x;
                const calculatedPosition = relativePosition / width;
                if (calculatedPosition > 0.001 && calculatedPosition < 1) {
                    this.clipPosition = calculatedPosition;
                } else if (calculatedPosition >= 1) {
                    this.clipPosition = 1;
                } else if (calculatedPosition <= 0.001) {
                    this.clipPosition = 0;
                }
            },
            onDragStart() {
                addEventListener('mousemove', this.handleMouseMove);
                addEventListener('touchmove', this.handleMouseMove);
            },
            onDragEnd() {
                removeEventListener('mousemove', this.handleMouseMove);
                removeEventListener('touchmove', this.handleMouseMove);
            },
        },
        mounted() {
            window.addEventListener('mouseup', this.onDragEnd);
            window.addEventListener('touchend', this.onDragEnd);
        },
        beforeDestroy() {
            removeEventListener('mousemove', this.handleMouseMove);
            removeEventListener('touchmove', this.handleMouseMove);
            window.removeEventListener('mouseup', this.onDragEnd);
            window.removeEventListener('touchend', this.onDragEnd);
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2a5cc223